import React, { useEffect } from "react";
import { array, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CrossIcon from "../../atoms/icons/cross-icon";

import { getRecentSearches } from "../../helper/localstorage";
import { setRecentSearch } from "../../helper/actions";

import "./recentSearch.m.css";

const RecentSearch = ({ list, onItemClick, setRecentSearch }) => {
  useEffect(() => {
    setRecentSearch(getRecentSearches(), true);
  }, []);

  if (!(list && list.length)) {
    return null;
  }

  // Remove recent search item on click
  const onRemoveClick = (index) => (e) => {
    const newList = list.filter((text, i) => i !== index);

    setRecentSearch(newList);
  };

  return (
    <div styleName="wrapper">
      <span styleName="recent-search-label">Recent Searches</span>

      <ul>
        {
          // Display only 5 recent searches
          list.slice(0, 5).map((text, index) => (
            <li key={index} styleName="list-item">
              <div styleName="item">
                <span styleName="text" onClick={onItemClick(text)}>
                  {text}
                </span>
                <div styleName="cross-icon" onClick={onRemoveClick(index)}>
                  <CrossIcon width={20} height={20} />
                </div>
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

RecentSearch.propTypes = {
  list: array,
  onItemClick: func.isRequired,
  setRecentSearch: func,
};

const mapStateToProps = (state) => ({
  list: get(state, ["settingsReducer", "recentSearchList"], []),
});

const mapDispatchToProps = (dispatch) => ({
  setRecentSearch: (list) => dispatch(setRecentSearch(list)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RecentSearch);
